<template lang="pug">
.form-input-standard-user-receive-messages-function.w-100
  .content.d-flex.flex-row.align-items-center
    span.error-message 詳細設定は受信メッセージを使用可にしないと有効になりません。

  //- 履歴（家族）閲覧の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showFamilyMessages") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showFamilyMessages")
  //- 履歴（施設関係者）閲覧の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showOtherUserMessages") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showOtherUserMessages")
  //- 返信（家族）の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("useFamilyReply") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useFamilyReply")
  //- 返信（施設関係者）の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("useOtherUserReply") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useOtherUserReply")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { ReceiveMessagesFunction, receiveMessagesFunctionNameMap } from "@/commons/services/Authorization";

import UsableFunctionSwitch from "@/pc/basics/UsableFunctionSwitch.vue";

/**
 * ### 一般ユーザーの使用機能選択コンポーネント(家族サービス、受信メッセージ)
 */
@Component({
  components: {
    UsableFunctionSwitch
  }
})
export default class FormInputStandardUserReceiveMessagesFunction extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: ReceiveMessagesFunction;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): ReceiveMessagesFunction {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: ReceiveMessagesFunction) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### メッセージ送信の項目名を返す
   */
  public getFunctionName(functionKeyName: string): string {
    const functionName: string | undefined = receiveMessagesFunctionNameMap.get(functionKeyName);
    return functionName ? functionName : "";
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.form-input-standard-user-receive-messages-function {
  margin-bottom: 12px;
  padding: 12px 12px 4px 12px;

  background-color: $hitomeq-gray;

  .content {
    margin-bottom: 8px;
    padding-right: 74px;

    .function-detail-name {
      margin-left: 16px;
    }
  }
}
</style>
